import { Link } from 'react-router-dom';
import Icon from '../components/Icons';
import Revelar from '../components/Revelar';
import servicos from '../data/servicos';
import { site, praca, linkWhatsApp } from '../config';
import { SLUG_BRASILIA } from '../seo';
import './ServicoPagina.css';
import './SobrePagina.css';

// ATENÇÃO: só entram aqui informações verificáveis. Nada de número de casos,
// resultados obtidos, prêmios ou titulação sem comprovação — além de vedado
// pelo Código de Ética da OAB, é o tipo de alegação que derruba a confiança
// do site inteiro se for contestada.
const registro = [
  'Advogado inscrito na Ordem dos Advogados do Brasil',
  site.oab,
  'Atuação dedicada a Direito Penal e Processo Penal',
  'Atendimento em todo o território nacional',
];

const compromissos = [
  {
    icone: 'patrimonio',
    titulo: 'Sigilo profissional',
    texto:
      'O dever de sigilo alcança tudo o que é dito, inclusive na consulta que não resulta em contratação. É obrigação legal do advogado, não uma cortesia.',
  },
  {
    icone: 'juri',
    titulo: 'Nenhuma promessa de resultado',
    texto:
      'Não se promete absolvição, soltura nem prazo. O que se apresenta é o que os autos permitem sustentar e quais são os cenários possíveis, com franqueza.',
  },
  {
    icone: 'economicos',
    titulo: 'Honorários por escrito',
    texto:
      'Valores, escopo e forma de pagamento são definidos e apresentados antes da contratação, observada a Tabela de Honorários da OAB.',
  },
  {
    icone: 'digitais',
    titulo: 'Você acompanha o processo',
    texto:
      'Atualização periódica sobre prazos, audiências e decisões, em linguagem compreensível para quem não é da área.',
  },
];

export default function SobrePagina() {
  return (
    <article className="sobre-pagina">
      <header className="servico-topo">
        <div className="container">
          <nav className="trilha" aria-label="Você está em">
            <ol>
              <li>
                <Link to="/">Início</Link>
              </li>
              <li>
                <span aria-current="page">O Advogado</span>
              </li>
            </ol>
          </nav>

          <div className="servico-topo__grade">
            <div>
              <span className="rotulo">O Advogado</span>
              <h1 className="servico-topo__titulo">
                {site.nome}
                <span className="sobre-pagina__cargo">
                  {site.cargo} · {site.oab}
                </span>
              </h1>

              <p className="servico-topo__texto">
                Atuação dedicada à área criminal, em todas as fases da
                persecução penal: do inquérito policial e da audiência de
                custódia à sustentação oral nos tribunais e ao acompanhamento da
                execução da pena.
              </p>
              <p className="servico-topo__texto">
                O trabalho parte de um princípio simples: nenhum caso é igual ao
                outro. Antes de qualquer tese vem o estudo dos autos, a conversa
                franca com o cliente e a definição de uma estratégia possível
                dentro daquilo que os fatos e a prova permitem. Quem procura um
                criminalista costuma estar no pior momento da própria vida — e
                merece ouvir o que é possível, não o que gostaria de escutar.
              </p>

              <div className="servico-topo__acoes">
                <a
                  className="btn btn--ouro"
                  href={linkWhatsApp()}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon name="whatsapp" size={18} />
                  Falar com o advogado
                </a>
                <Link className="btn btn--contorno" to="/contato">
                  Canais de atendimento
                  <Icon name="seta" size={18} />
                </Link>
              </div>
            </div>

            <aside className="servico-topo__cartao">
              <span className="servico-topo__icone" aria-hidden="true">
                <Icon name="juri" size={28} />
              </span>
              <h2>Registro profissional</h2>
              <ul>
                {registro.map((item) => (
                  <li key={item}>
                    <Icon name="check" size={16} />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <p className="servico-topo__legal">
                A inscrição pode ser conferida no cadastro nacional de advogados
                do Conselho Federal da OAB.
              </p>
            </aside>
          </div>
        </div>
      </header>

      {/* ---------- onde atua ---------- */}
      <section className="secao secao--escura">
        <div className="container servico-alcance">
          <Revelar className="servico-alcance__nacional">
            <span className="rotulo">Onde atua</span>
            <h2 className="titulo-secao">Todo o Brasil, com base em Brasília</h2>
            <p>
              A orientação inicial, a análise dos documentos e as reuniões são
              feitas por videoconferência, o que permite atender clientes de
              qualquer estado. O deslocamento presencial acontece quando o ato
              exige — audiência, sustentação oral, diligência ou atendimento em
              delegacia — e é combinado por escrito antes da contratação.
            </p>
            <p>
              Estar em Brasília não restringe a atuação: amplia. O Superior
              Tribunal de Justiça e o Supremo Tribunal Federal ficam na cidade.
              Quando um caso de outro estado chega à fase recursal, protocolo,
              memoriais em gabinete e sustentação oral acontecem presencialmente,
              sem depender de advogado correspondente.
            </p>
            <Link className="servico-alcance__link" to={`/${SLUG_BRASILIA}`}>
              Atuação no Distrito Federal
              <Icon name="seta" size={17} />
            </Link>
          </Revelar>

          <Revelar className="servico-alcance__local" atraso={120}>
            <span className="servico-alcance__selo">
              <Icon name="local" size={18} />
              {praca}
            </span>
            <h2>Como é o atendimento</h2>
            <p>{site.atuacao.presencial}. {site.atuacao.remoto}.</p>
            <p>
              {site.horario}. {site.plantao}.
            </p>
          </Revelar>
        </div>
      </section>

      {/* ---------- compromissos ---------- */}
      <section className="secao">
        <div className="container">
          <div className="cabecalho-secao">
            <span className="rotulo">Como trabalho</span>
            <h2 className="titulo-secao">Quatro compromissos</h2>
          </div>

          <ul className="compromissos">
            {compromissos.map((item, indice) => (
              <Revelar as="li" key={item.titulo} atraso={indice * 90}>
                <Icon name={item.icone} size={26} />
                <h3>{item.titulo}</h3>
                <p>{item.texto}</p>
              </Revelar>
            ))}
          </ul>
        </div>
      </section>

      {/* ---------- áreas ---------- */}
      <section className="secao secao--escura">
        <div className="container">
          <div className="cabecalho-secao">
            <span className="rotulo">Áreas de atuação</span>
            <h2 className="titulo-secao">Em que tipo de caso a defesa entra</h2>
          </div>

          <ul className="sobre-pagina__areas">
            {servicos.map((servico) => (
              <li key={servico.id}>
                <Link to={`/${servico.slug}`}>
                  <Icon name={servico.icone} size={19} />
                  {servico.titulo}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="servico-chamada">
        <div className="container servico-chamada__interno">
          <div>
            <h2>Quer conversar sobre um caso?</h2>
            <p>
              O primeiro contato é sigiloso e não gera compromisso. Casos
              urgentes têm prioridade.
            </p>
          </div>
          <a
            className="btn btn--claro"
            href={linkWhatsApp()}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="whatsapp" size={18} />
            Falar agora
          </a>
        </div>
      </section>
    </article>
  );
}
